import { isRepeatableProductFormat } from './varietyFormatIdentity';

export const isFormatStockPurchase = (stock = {}) => ['pack', 'other'].includes(stock?.purchaseMode);
export const isRegistryStockPurchase = (stock = {}) => Boolean(stock.purchaseFormatId || stock.sellingFormatId
  || stock.sellingSnapshot || (stock.purchaseMode === 'pack' && stock.purchaseSnapshot && !stock.purchaseVarietyPriceId));

export const getPurchasePackFormats = (formats = [], { includeIncomplete = false } = {}) => formats.filter((format) => {
  const type = format.ProductFormat || format.productFormat || {};
  const code = String(format.productFormatCode || type.code || '').trim().toLowerCase();
  return Boolean(code) && isRepeatableProductFormat(format) && type.isActive !== false
    && format.productFormatActive !== false && format.productFormatIsActive !== false
    && !format.isDeleted && !format.retiredAt && format.id != null && (includeIncomplete || (String(format.metricUnit || '').trim()
      && Number.isFinite(Number(format.unitWeightKg)) && Number(format.unitWeightKg) > 0));
});

export const purchasePackLabel = (format = {}) => `${String(format.metricUnit || '').trim()} · ${Number(format.unitWeightKg || 0).toLocaleString('es-CL', { maximumFractionDigits: 3 })} kg`;

export const purchaseSelectorValue = (draft = {}) => draft.purchaseMode === 'pack'
  ? `pack:${draft.purchaseVarietyPriceId || ''}` : draft.purchaseMode || '';

// Only an explicit selection refreshes the local display from the catalog. An
// existing purchase keeps its recorded unit and weight when the catalog changes.
export const selectStockPurchase = (draft, selection, formats = []) => {
  const format = selection.startsWith('pack:')
    ? getPurchasePackFormats(formats).find((entry) => String(entry.id) === selection.slice(5)) : null;
  const mode = format ? 'pack' : ['other', 'granel'].includes(selection) ? selection : '';
  const next = {
    ...draft, formatContractVersion: 2, historicalFormat: false, purchaseMode: mode, purchaseVarietyPriceId: format?.id || null,
    sellingVarietyPriceId: format?.id || null, sellingMetricUnit: '', sellingWeightKg: '', sellingOther: false,
    metricUnit: format ? format.metricUnit : mode === 'granel' ? 'granel' : '',
    weight: format ? String(format.unitWeightKg) : '', unitsPerPack: '', bultosPerBin: '',
  };
  if (mode === 'granel' && draft.purchaseMode !== 'granel') {
    const multiplier = Number(draft.quantity) > 0 ? Number(draft.quantity) : 1;
    for (const field of ['price', 'priceWithoutIva', 'weight']) {
      next[field] = String(draft[field] ?? '').trim() ? String(Number(draft[field]) * multiplier) : '';
    }
    next.quantity = '1';
  }
  return next;
};

export const getPurchaseFormatError = (draft = {}, { allowUnlinkedPack = false, allowLegacyGranel = false } = {}) => {
  if (draft.historicalFormat) return '';
  if (!['pack', 'other', 'granel'].includes(draft.purchaseMode)) return 'Selecciona el formato de compra.';
  if (draft.purchaseMode === 'pack' && !draft.purchaseVarietyPriceId && !allowUnlinkedPack) return 'Selecciona un pack de esta variedad.';
  if (!String(draft.metricUnit || '').trim()) return 'Ingresa la unidad métrica del formato comprado.';
  if (!(Number(draft.weight ?? draft.weightKg) > 0)) return 'Ingresa un peso mayor a 0 kg.';
  if (draft.purchaseMode === 'granel' && !allowLegacyGranel && !draft.sellingVarietyPriceId
    && !(draft.sellingOther && String(draft.sellingMetricUnit || '').trim() && Number(draft.sellingWeightKg) > 0)) return 'Selecciona el pack de venta o propón uno con Otro.';
  return '';
};

export const stockRegistryDraft = (stock = {}) => ({
  formatContractVersion: stock?.formatContractVersion ?? null,
  formatRevision: stock?.formatRevision ?? 1,
  historicalFormat: Boolean(stock?.id && !stock.formatContractVersion),
  sellingVarietyPriceId: stock?.sellingVarietyPriceId ?? null,
  sellingMetricUnit: stock?.sellingSnapshot?.metricUnit || '',
  sellingWeightKg: stock?.sellingSnapshot?.weightKg != null ? String(stock.sellingSnapshot.weightKg) : '',
  sellingOther: stock?.purchaseMode === 'granel' && !stock?.sellingVarietyPriceId,
  ...(['pending', 'changes_requested'].includes(stock?.formatReviewStatus) && !stock?.purchaseMode ? { purchaseMode: 'other' } : {}),
});

export const stockPurchaseFields = (draft, { preserveLegacyGranel = false } = {}) => {
  if (draft.historicalFormat || preserveLegacyGranel) return {};
  return {
    formatContractVersion: 2, ...(draft.formatRevision ? { formatRevision: Number(draft.formatRevision) } : {}),
    purchaseMode: draft.purchaseMode,
    purchaseVarietyPriceId: draft.purchaseMode === 'pack' ? Number(draft.purchaseVarietyPriceId) : null,
    ...(draft.purchaseMode === 'granel' ? { sellingVarietyPriceId: draft.sellingVarietyPriceId || null,
      ...(!draft.sellingVarietyPriceId ? { sellingMetricUnit: draft.sellingMetricUnit || '', sellingWeightKg: Number(draft.sellingWeightKg) } : {}) } : {}),
    metricUnit: String(draft.metricUnit || '').trim(), weight: Number(draft.weight), weightKg: Number(draft.weight),
  };
};
